function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#1CA2E1",
  fillRule: "evenodd",
  d: "M8 0C3.589 0 0 3.589 0 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm0 12.304a.77.77 0 11-.001-1.541A.77.77 0 018 12.305zm.835-7.736l-.22 4.692a.615.615 0 01-1.231 0l-.22-4.69v-.002a.834.834 0 011.263-.754c.264.158.42.447.407.754h.001z"
});

var SvgAlert = function SvgAlert(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICAgIDxwYXRoIGZpbGw9IiMxQ0EyRTEiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTggMEMzLjU4OSAwIDAgMy41ODkgMCA4czMuNTg5IDggOCA4IDgtMy41ODkgOC04LTMuNTg5LTgtOC04em0wIDEyLjMwNGMtLjQyNSAwLS43Ny0uMzQ0LS43Ny0uNzY5IDAtLjQyNS4zNDUtLjc3Ljc3LS43Ny40MjUgMCAuNzcuMzQ1Ljc3Ljc3IDAgLjQyNS0uMzQ1Ljc3LS43Ny43N3ptLjgzNS03LjczNmwtLjIyIDQuNjkyYzAgLjM0LS4yNzYuNjE1LS42MTYuNjE1LS4zNCAwLS42MTUtLjI3NS0uNjE1LS42MTVsLS4yMi00LjY5di0uMDAyYy0uMDE0LS4zMDcuMTQyLS41OTYuNDA2LS43NTQuMjY0LS4xNTcuNTkzLS4xNTcuODU3IDAgLjI2NC4xNTguNDIuNDQ3LjQwNy43NTRoLjAwMXoiLz4KPC9zdmc+Cg==";
export { SvgAlert as ReactComponent };